import React, { useState } from 'react';
import { Button } from '../../ui/Button';
import { Input } from '../../ui/Input';

export const CompleteNote = ({ onConfirm, onCancel }) => {
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async () => {
    if (busy) return;
    setBusy(true);
    setError('');
    try {
      await onConfirm(note);
    } catch (err) {
      setError(err.message || 'Could not complete the follow-up.');
      setBusy(false);
    }
  };

  return (
    <div className="space-y-2 bg-green-50/50 border border-green-100 rounded-xl p-3">
      <Input
        placeholder="Optional note (e.g., Sent the proposal)"
        value={note}
        onChange={(e) => setNote(e.target.value)}
        maxLength={1000}
      />
      {error && <p className="text-sm font-medium text-red-600">{error}</p>}
      <div className="flex gap-2">
        <Button size="sm" onClick={submit} isLoading={busy}>Mark complete</Button>
        <Button size="sm" variant="ghost" onClick={onCancel} disabled={busy}>Cancel</Button>
      </div>
    </div>
  );
};